<!-- 
    
    <v-card-text></v-card-text>
      <v-btn @click="saveFilterTodb(formData)" text> Enregistrer pour reprendre</v-btn><v-card-actions>
    </v-card-actions> 
  -->
<template>
  <v-form class="px-7" style="max-width: 890px; margin-left: auto; margin-right: auto">
    <h2 class="text-center">Bon de commande obsèques</h2>

    <v-progress-linear
      v-if="loading && formData.e6 == ''"
      color="primary"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>
    <v-stepper v-model="formData.e6" class="mt-2">
      <v-stepper-header style="height: 100%; width: 100%" v-if="formData.e6 !== 9">
        <v-row>
          <v-stepper-step editable :complete="formData.e6 > 0" step=""> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 1" :step="1"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 2" :step="2"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 3" :step="3"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 4" :step="4"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 5" :step="5"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 6" :step="6"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 7" :step="7"> </v-stepper-step>
        </v-row>
      </v-stepper-header>
      <p class="mb-3 mt-6 text-center text-h6">{{ title }}</p>
      <v-stepper-items>
        <v-stepper-content step="">
          <v-container class="pt-0">
            <v-card flat class="text-center">
              <v-card-title class="mb-5 text-center d-flex justify-center">
                <v-row>
                  <v-col class="pa-0" cols="12">
                    <v-chip-group
                      column
                      mandatory
                      active-class="primary--text"
                      @change="formData.type = $event"
                      class="mb-3"
                    >
                      <v-chip @click="formData.e6 = 1"> Particulier </v-chip>
                      <v-chip @click="formData.e6 = 1"> Professionnel </v-chip>
                    </v-chip-group>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
                <!-- choix particulier pro  -->
              </v-card-text>
            </v-card>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="1">
          <v-container>
            <v-card flat>
              <v-card-text>
                <!-- choix particulier pro  -->

                <!-- particulier -->
                <div v-if="formData.type == 0">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        :messages="
                          VarLab.map((e) => e.label)[
                            VarLab.map((e) => e.nomVariable).indexOf('Nom')
                          ]
                        "
                        v-model="formData.Nom"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Prénom"
                        v-model="formData.Prénom"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Votre adresse postale"
                        v-model="formData.adressePostaleParticulier"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        telNom
                        rows="1"
                        hide-details="auto"
                        outlined
                        :messages="
                          VarLab.map((e) => e.label)[
                            VarLab.map((e) => e.nomVariable).indexOf('tel')
                          ]
                        "
                        v-model="formData['tel']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        v-model="formData['mail']"
                        messages="E-mail"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </div>
                <!-- pro -->
                <div v-else>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Nom de la structure"
                        v-model="formData['nomDeLaStructure']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Siret"
                        v-model="formData['Siret']"
                        required
                      ></v-textarea>
                    </v-col>
                    <!-- <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Code APE"
                        v-model="formData['CodeAPE']"
                        required
                      ></v-textarea>
                    </v-col> -->
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Représentée par (en sa qualité de):"
                        v-model="formData['représentant']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Adresse postale de correspondance:"
                        v-model="formData['Adresse']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Numéro de téléphone fixe"
                        v-model="formData['telFixe']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Numéro de téléphone mobile "
                        v-model="formData['telMob']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        v-model="formData['mail']"
                        messages="E-mail"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-container>
            <v-card class="mb-20" flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      :items="$store.state.groupes"
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Nom du groupe de Gospel que vous souhaitez retenir:"
                      v-model="formData['groupe']"
                      required
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-select
                      :items="formules"
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Combien de chanteurs et musiciens souhaités"
                      v-model="formData['nbChanteurs']"
                      required
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-textarea
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Tarif de cette formule indiquée sur le devis (déplacements inclus)"
                      v-model="formData['tarif']"
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-card flat>
            <v-card-text>
              <v-row>
                <!-- date -->
                <v-col cols="12" md="6">
                  <v-text-field
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    type="date"
                    v-model="formData.date"
                    messages="Date de la cérémonie:"
                  ></v-text-field>
                </v-col>
                <!-- Nom de la ville:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Nom de la ville: "
                    v-model="formData['nomVille']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Code postal de cette commune:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Code postal de cette commune: "
                    v-model="formData['cp']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Type de lieu de la cérémonie (église, domaine, mairie,..):  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Type de lieu de la cérémonie (église, funérarium) :"
                    v-model="formData['lieuCérémonie']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Lien Google Maps du lieu de la prestation (important):-->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Lien Google Maps du lieu de la prestation (important): "
                    v-model="formData['lienGoogleMapslieuCérémonie']"
                    required
                  ></v-textarea>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.google.fr/maps"
                    >Accéder à google maps</a
                  >
                </v-col>
                <!-- Adresse précise du lieu de la cérémonie (pour vérification) :  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Adresse précise du lieu de la cérémonie (pour vérification)"
                    v-model="formData['AdresselieuCérémonie']"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-card flat>
            <v-card-text>
              <v-row>
                <!-- Personne référente (autre que vous) qui recevra un SMS pour informer de l’arrivée du groupe:  -->
                <!-- <v-col cols="12">
                  <p class="mx-5">
                    Personne référente (autre que vous) qui recevra un SMS pour informer de
                    l’arrivée du groupe:
                  </p>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Nom-Prénom"
                    v-model="formData['personneRefNomPrenom']"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Tél mobile"
                    v-model="formData['personneRefTel']"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Quel lien familial/amical: "
                    v-model="formData['personneRefLien']"
                    required
                  ></v-textarea>
                </v-col> -->
                <!-- Heure précise du début de l’événement (le groupe arrivera 90 min avant) :   -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Heure précise du début de l’événement (le groupe arrivera 90 min avant) :  "
                    v-model="formData['heureDebEven']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Quelle sera la durée de la cérémonie -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Quelle sera la durée de la cérémonie :"
                    v-model="formData['dureeCer']"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="['Obsèques']"
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Type de cérémonie :"
                    v-model="formData['typeCer']"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="5">
          <v-card flat>
            <v-card-text>
              <v-row>
                <!-- Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :  -->
                <v-col cols="12" md="6">
                  <!-- <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :"
                    v-model="formData['tenues']"
                    required
                  ></v-textarea> -->
                  <v-select
                    :items="['Toges', 'En noir']"
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :"
                    v-model="formData['tenues']"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Combien de personnes sont attendues :"
                    v-model="formData['nbInvites']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe:"
                    v-model="formData['autresDemandes']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- <v-col cols="12">
                  Si cérémonie en extérieur (sonorisation non gérée par le groupe),
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Quel est le contact de la personne qui devra mettre en place et gérer la sonorisation durant toute la prestation du groupe:"
                    v-model="formData.nomPerGerSono"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Cette personne a-t-elle confirmé qu’elle respectera parfaitement la fiche technique ? :"
                    v-model="formData['confRespFichTechSono']"
                    required
                  ></v-textarea>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="6">
          <v-card>
            <v-card-text class="text-center">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <p>
                      Le chef de chœur souhaiterait mieux connaître qui est cette personne dont nous
                      allons célébrer les obsèques. Cela lui permettra de bien préparer les
                      artistes, qui comprendront mieux ce que vous vivez:
                    </p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Nom et prénom de cette personne :"
                      v-model="formData['Nom et prénom du défun']"
                      required
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Qui était-ce dans votre famille (père, mère ? ...) :"
                      v-model="formData['position dans la famille']"
                      required
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Dans quelles conditions cette personne vous a quitté :"
                      v-model="formData['Dans quelles conditions']"
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="7">
          <v-card>
            <v-card-text>
              <!-- <div>
                <p align="JUSTIFY">
                  La SARL SAY PRODUCTION (nom de marque GOSPEL EVENT), au capital de 5.000 €, No de
                  Siret 512 972 803 000 13 Code APE : 9001 Z, dont le siège est situé au 45 grand
                  rue, 34260 CEILHES, réalise des prestations de chants Gospel pour cérémonies et
                  concerts. Vous pouvez nous joindre au 07 68 88 94 36‬, ou par mail à
                  virginie.gospelevent@icloud.com
                  <br />
                  <strong>
                    L’envoi de ce bon de commande complété intégralement ou partiellement, et
                    renvoyé par mail, fait office de contrat signé électroniquement. Cela vous
                    engage donc l’achat de la prestation que vous avez détaillée sur la page
                    précédente.</strong
                  >
                  Dès réception de votre commande, nous la vérifions et nous la transmettons
                  immédiatement au coordinateur du groupe que vous souhaitez réserver.
                  <br />
                  Si ce groupe ne peut valider votre bon de commande, celui-ci sera automatiquement
                  annulé mais nous pourrons si vous le souhaitez, vous aider à réserver un autre
                  groupe.
                  <br />
                  Si le groupe valide, nous vous attestons cela par retour de mail et votre bon de
                  commande tient alors lieu de contrat ferme entre vous et nous.
                  <br />
                  La prestation sera composée de maximum 7 chants. Le nombre sera notamment
                  déterminé par le plan de messe négocié entre vous et l’officiant.
                  <br />
                  <br />
                  <strong>Votre règlement devra nous parvenir :</strong> par virement sous 72h
                  maximum après la cérémonie.<br />
                  Il devra comporter le No votre de votre facture qui vous sera communiqué
                  prochainement.<br />
                  Aucun acompte n’est obligatoire.<br />
                  Nous vous contacterons par téléphone le lendemain de la cérémonie pour nous
                  assurer de votre entière satisfaction, et nous nous confirmerons la période
                  souhaitée pour le règlement, que vous pourrez modifier si vous le souhaitez.
                  <br />
                  Si l’officiant devait à un moment des préparatifs ou de la cérémonie, revoir le
                  nombre de chants ou leur durée, ceci ne saurait constituer une condition
                  d’annulation de commande.<br />

                  Si à la suite de l’événement, des amis ou des connaissances demandent le contact
                  du groupe, le client s’engage à fournir uniquement le contact du site web Gospel
                  Event : www.gospel-event.com
                  <br />
                  Cette commande pourra être annulée de plein droit et sans préavis sous réserve
                  d’une entente mutuelle. Autrement vous nous serez redevable d’une somme de
                  dédommagement du montant intégral de cette prestation (moins les frais de
                  déplacements).
                  <br />
                  En cas de litige portant sur l’interprétation ou l’application de cette commande,
                  les parties conviennent de s’en remettre à l’appréciation du Tribunal de
                  Montpellier.
                </p>
              </div> -->
              <div>
                <p>
                  <span class="c0"
                    >La SARL SAY PRODUCTION (nom de marque GOSPEL EVENT), au capital de 5.000 €, No
                    de Siret 512 972 803 000 13 , dont le siège est situé au 45
                    grand rue, 34260 CEILHES, réalise des prestations de chants Gospel pour
                    cérémonies et concerts. Vous pouvez nous joindre au 07 68 88 94 36, ou par mail
                    à virginie.gospelevent@icloud.com <br /><br />
                    Dès réception de votre commande, nous la vérifions et nous la transmettons
                    immédiatement au coordinateur du groupe que vous souhaitez réserver.
                    <br /><br />
                    Si ce groupe ne peut valider votre bon de commande, celui-ci sera
                    automatiquement annulé mais nous pourrons si vous le souhaitez, vous aider à
                    réserver un autre groupe.
                    <br /><br />
                    Si le groupe valide, nous vous attestons cela par retour de mail. Ce bon de
                    commande sera ensuite signé électroniquement, nous engageant fermement
                    mutuellement pour la prestation. La prestation sera composée de maximum 7
                    chants. Le nombre sera notamment déterminé par le plan de messe négocié entre
                    vous et l’officiant. Le groupe ne prendra pas en charge les chants religieux en
                    français.
                    <br /><br />
                    <span class="c4 c6">La totalité de votre règlement devra nous parvenir </span>
                    par virement sous 72h maximum après la cérémonie.<br />
                    Le libellé du virement devra mentionner le numéro de votre facture qui vous sera
                    communiqué prochainement.
                    <br /><br />
                    Nous vous contacterons par téléphone le lendemain de la cérémonie pour nous
                    assurer de votre entière satisfaction.
                    <br /><br />
                    Si l’officiant devait à un moment des préparatifs ou de la cérémonie, revoir le
                    nombre de chants ou leur durée, ceci ne saurait constituer une condition
                    d’annulation de votre commande.
                    <br /><br />
                    Si à la suite de la cérémonie, des amis ou des connaissances demandent le
                    contact du groupe, le client s’engage à fournir uniquement le lien du site web
                    Gospel Event : www.gospel-event.com
                    <br /><br />
                    Cette commande pourra être annulée de plein droit et sans préavis sous réserve
                    d’une entente mutuelle. Autrement vous nous serez redevable d’une somme de
                    dédommagement du montant intégral de cette prestation (moins les frais de
                    déplacements).
                    <br /><br />
                    En cas de litige portant sur l’interprétation ou l’application de cette
                    commande, les parties conviennent de s’en remettre à l’appréciation du Tribunal
                    de Montpellier.
                  </span>
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8">
          <v-card>
            <v-card-text class="text-center my-5">
              Merci de vérifier l'exactitude des informations saisies
            </v-card-text>
            <v-list-item-group color="primary">
              <template v-for="(item, i) in formData">
                <v-list-item
                  :key="i"
                  v-if="VarLab.map((e) => e.nomVariable).indexOf(i) !== -1 && item !== ' '"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="
                        VarLab.map((e) => e.label)[VarLab.map((e) => e.nomVariable).indexOf(i)]
                      "
                    ></v-list-item-title>
                    <v-list-item-subtitle>{{ testIfitIsADate(item) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="9">
          <v-card>
            <v-card-text class="text-center my-5">
              Merci beaucoup pour ce bon de commande, <br />
              vous serez recontacté très prochainement 👏
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="10"> </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-row class="mt-5">
      <v-col class="text-center mb-6 px-0" v-if="formData.e6 !== 9">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading && userSaving"
          x-small
          v-if="formData.e6 !== '' && formData.e6 !== '1'"
          @click="testIfFirstTimeSaveAndSendEmail()"
          text
          color="grey"
        >
          <div>
            <span class="first-line">Enregistrer pour</span><br />
            <span class="second-line">plus tard</span>
          </div>
          <!-- <div v-else>
            <span class="first-line">Enregistré</span>
          </div> -->
        </v-btn>

        <v-btn class="mr-2" small v-if="formData.e6 !== ''" text @click="goBack"> Retour </v-btn>
        <v-btn v-if="formData.e6 !== 8" small color="primary" @click="goNext"> Suivant </v-btn>
        <!-- <v-btn v-if="formData.e6 == 1" small color="primary" @click="sendEmailToUserToResume()">
          Suivant
        </v-btn> -->
        <v-btn v-if="formData.e6 == 8" small color="primary" @click="sendFinalBDC()">
          Envoyer
        </v-btn>
      </v-col>
      <v-col class="text-center mb-6" v-else>
        <v-spacer></v-spacer>
        <v-btn
          v-if="admin"
          small
          color="primary"
          @click="
            printDiv2(
              'toPrint',
              `BDC Obsèques ${formatDate(formData.date)} ${formData.nomVille} ${formData.groupe}`
            )
          "
        >
          Telecharger mon BDC
        </v-btn>
        <!-- <v-btn small color="primary" @click="printDiv2('toPrint')"> Telecharger mon BDC </v-btn> -->
      </v-col>
    </v-row>
    <pdf-to-print id="toPrint" style="display: none" :data="formData"></pdf-to-print>
    <!-- <pdf-to-print id="toPrint" style="display: block" :data="formData"></pdf-to-print> -->
    <v-snackbar v-model="snackbar" :timeout="timeout" color="primary">
      {{ text }}
    </v-snackbar>
  </v-form>
</template>

<script>
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import pdfToPrint from "../pages/PdfObseques.vue";
// import { query } from "@firebase/firestore";
export default {
  components: { pdfToPrint },
  props: {
    // url_data,
  },
  async mounted() {
    var id = this.$route.query.id;
    console.log(this.$route);
    if (id !== undefined) {
      this.currentUserId = id;
      this.getDataOfExistingUser(id);
    } else {
      // create new user id and save it in bdd
      this.currentUserId = this.generateNewUserId();
      this.createNewUserInBDD();
    }
    var admin = this.$route.query.admin;
    if (admin == "true") {
      this.admin = true;
    }

    // firs
    var vm = this;
    this.intervalId = window.setInterval(function () {
      /// call your function here
      if (vm.dataChange) {
        vm.saveCurrentData();
      }
    }, 10000);
  },
  beforeUpdate() {
    clearInterval(this.intervalId);
  },
  updated() {
    var vm = this;
    this.intervalId = window.setInterval(function () {
      /// call your function here
      // console.log("save every 10 second");
      if (vm.dataChange) {
        vm.saveCurrentData();
      }
    }, 10000);
  },
  data: () => ({
    userSaving: false,
    admin: false,
    snackbar: false,
    text: "Nous vous avons envoyé un e-mail",
    timeout: 2000,
    intervalId: "",
    reglementType23: "3",
    emailSent: false,
    currentUserId: "",
    loading: false,
    tmpLastChange: "",
    tmpLastSave: "",
    dataChange: false,
    formules: [
      "1 choriste + 1 pianiste",
      "2 choristes dont 1 pianiste",
      "2  choristes + 1 pianiste",
      "3 choristes a capella",
      "3 choristes dont 1 pianiste",
      "3  choristes + 1 pianiste",
      "4 choristes a capella",
      "4 choristes dont  1 pianiste",
      "4 choristes + 1 pianiste",
      "5 choristes a capella",
      "5 choristes dont un pianiste",
      "5 choristes + 1 pianiste",
      "autre formule avec plus d'artiste",
    ],
    formData: {
      id: "",
      Nom: " ",
      Prénom: " ",
      adressePostaleParticulier: " ",
      e6: "",
      type: 0,
      mail: null,
      Siret: " ",
      CodeAPE: " ",
      nomDeLaStructure: " ",
      représentant: " ",
      Adresse: " ",
      tel: " ",
      telMob: " ",
      telFixe: " ",
      groupe: null,
      nbChanteurs: null,
      tarif: null,
      nomVille: null,
      date: "",
      cp: null,
      lieuCérémonie: null,
      lienGoogleMapslieuCérémonie: null,
      AdresselieuCérémonie: null,
      personneRefNomPrenom: null,
      personneRefTel: null,
      personneRefLien: null,
      heureDebEven: null,
      dureeCer: null,
      typeCer: "Obsèques",
      tenues: null,
      nbInvites: null,
      autresDemandes: null,
      "Nom et prénom du défun": "",
      "position dans la famille": "",
      "Dans quelles conditions": "",
      emailSent: "",
    },
    VarLab: [
      { nomVariable: "Nom", label: "Nom" },
      { nomVariable: "Prénom", label: "Prénom" },
      { nomVariable: "adressePostaleParticulier", label: "Votre adresse postale" },
      { nomVariable: "tel", label: "Numéro de téléphone" },
      { nomVariable: "mail", label: "E-mail" },
      { nomVariable: "nomDeLaStructure", label: "Nom de la structure" },
      { nomVariable: "Siret", label: "Siret" },
      // { nomVariable: "CodeAPE", label: "Code APE" },
      { nomVariable: "représentant", label: "Représentée par (en sa qualité de)" },
      { nomVariable: "Adresse", label: "Adresse postale de correspondance" },
      { nomVariable: "telFixe", label: "Numéro de téléphone fixe" },
      { nomVariable: "telMob", label: "Numéro de téléphone mobile " },
      { nomVariable: "mail", label: "E-mail" },
      { nomVariable: "groupe", label: "Nom du groupe de Gospel que vous souhaitez retenir" },
      { nomVariable: "nbChanteurs", label: "Combien de chanteurs et musiciens souhaités" },
      {
        nomVariable: "tarif",
        label: "Tarif de cette formule indiquée sur le devis (déplacements inclus)",
      },

      { nomVariable: "date", label: "Date de la cérémonie" },
      { nomVariable: "nomVille", label: "Nom de la ville" },
      { nomVariable: "cp", label: "Code postal de cette commune" },
      {
        nomVariable: "lieuCérémonie",
        label: "Type de lieu de la cérémonie (église, funérarium) ",
      },
      {
        nomVariable: "lienGoogleMapslieuCérémonie",
        label: "Lien Google Maps du lieu de la prestation (important)",
      },
      {
        nomVariable: "AdresselieuCérémonie",
        label: "Adresse précise du lieu de la cérémonie (pour vérification)",
      },
      // { nomVariable: "personneRefNomPrenom", label: "Nom-Prénom" },
      // { nomVariable: "personneRefTel", label: "Tél mobile" },
      // { nomVariable: "personneRefLien", label: "Quel lien familial/amical" },
      {
        nomVariable: "heureDebEven",
        label: "Heure précise du début de l’événement (le groupe arrivera 90 min avant)",
      },
      { nomVariable: "dureeCer", label: "Quelle sera la durée de la cérémonie" },
      { nomVariable: "typeCer", label: "Type de cérémonie" },
      {
        nomVariable: "tenues",
        label: "Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée)",
      },

      { nomVariable: "nbInvites", label: "Combien de personnes sont attendues" },
      {
        nomVariable: "autresDemandes",
        label: "Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe",
      },

      {
        nomVariable: "Nom et prénom du défun",
        label: "Nom et prénom de cette personne",
      },
      {
        nomVariable: "position dans la famille",
        label: "Qui était-ce dans votre famille (père, mère ? ...)",
      },
      {
        nomVariable: "Dans quelles conditions",
        label: "Dans quelles conditions cette personne vous a quitté",
      },
    ],

    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    menu: false,
    modal: false,

    selectedCommId: null,

    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],

    email1: "",
    emailRules1: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),
  computed: {
    cgv() {
      return this.$store.state.cgv;
    },
    title() {
      var titre = "titre";
      if (this.formData.e6 == "") {
        titre = "Vous êtes ?";
      } else if (this.formData.e6 == 1) {
        titre = "VOS COORDONNÉES";
      } else if (this.formData.e6 == 2) {
        titre = "VOTRE GROUPE GOSPEL";
      } else if (this.formData.e6 == 3) {
        titre = "DATE ET LIEU DE L’ÉVÉNEMENT";
      } else if (this.formData.e6 == 4) {
        titre = "PRÉCISIONS LOGISTIQUES";
      } else if (this.formData.e6 == 5) {
        titre = "PRÉCISIONS LOGISTIQUES (fin)";
      } else if (this.formData.e6 == 6) {
        titre = "PRÉCISIONS POUR LA PRÉPARATION DES ARTISTES";
      } else if (this.formData.e6 == 7) {
        titre = "Conditions générales de vente";
      } else if (this.formData.e6 == 8) {
        titre = "RECAP";
      } else if (this.formData.e6 == 9) {
        titre = "";
      }

      return titre;
    },
  },
  methods: {
    testIfFirstTimeSaveAndSendEmail() {
      // sendEmailToUser
      this.userSaving = true;
      this.sendEmailToUserToResume();
      //save data
      this.saveCurrentData();
    },
    // printDiv2(printpage, name) {
    //   document.title = name;
    //   // var style = document.getElementsByTagName("style")[0].outerHTML;
    //   var headstr = `<html><head><title>${name}</title></head><body>`;
    //   var newstr = document.all.item(printpage).innerHTML;
    //   console.log(newstr);
    //   var oldstr = document.body.innerHTML;
    //   document.body.innerHTML = headstr + newstr;
    //   window.print();
    //   document.body.innerHTML = oldstr;
    //   return true;
    // },
    printDiv2(printpage, name) {
      // Save the original document title
      const originalTitle = document.title;
      document.title = name;

      // Get the contents to print
      const printContent = document.getElementById(printpage).innerHTML;

      // Save the current document content
      const originalContent = document.body.innerHTML;

      // Create a new document structure for printing
      const newDocumentContent = `
    <html>
      <head>
        <title>${name}</title>
        <style>
          ${Array.from(document.styleSheets)
            .map((styleSheet) => {
              try {
                return Array.from(styleSheet.cssRules)
                  .map((rule) => rule.cssText)
                  .join("");
              } catch (e) {
                return "";
              }
            })
            .join("")}
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `;

      // Replace the current document content with the new one
      document.body.innerHTML = newDocumentContent;

      // Ensure images are loaded before printing
      const images = document.body.getElementsByTagName("img");
      const imagesLoaded = Array.from(images).map((img) => {
        return new Promise((resolve, reject) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = reject;
          }
        });
      });

      // Wait for all images to load, then print
      Promise.all(imagesLoaded)
        .then(() => {
          window.print();
        })
        .catch((error) => {
          console.error("Error loading images:", error);
        })
        .finally(() => {
          // Restore the original document content and title
          document.body.innerHTML = originalContent;
          document.title = originalTitle;
        });

      return true;
    },
    printDiv(divId, title) {
      var vm = this;
      vm.loading = true;
      var element = document.getElementById(divId);
      var clonedElement = element.cloneNode(true);
      clonedElement.style = "";
      document.body.appendChild(clonedElement);
      html2canvas(clonedElement, { scale: 5 }).then((canvas) => {
        clonedElement.remove();
        var imgData = canvas.toDataURL("image/png");
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        var doc = new jsPDF("p", "mm");
        var position = 0;

        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 10) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save(title + ".pdf");
        vm.loading = false;
        this.dataChange = false;
      });
    },
    sendEmailToUserToResume() {
      //verifier si email no send
      if (
        this.currentUserId !== "" &&
        this.formData.mail !== "" &&
        this.formData.mail !== null &&
        this.formData.emailSent == ""
      ) {
        console.log("create user", this.formData.mail);
        this.formData.emailSent = true;
        var email = this.formData.mail;
        var object = "Pour finir de compléter votre bon de commande Gospel Event";
        var message = this.firstTimeConnectionMsg(this.currentUserId);
        this.sendEmail(email, object, message);
      }
    },
    generateAndsendNewLink() {
      console.log("sendEmail");
      this.currentUserId = this.generateNewUserId();
      var email = this.formData.mail;
      var object = "Bienvenu dans Gospel App BDC";
      var message = this.firstTimeConnectionMsg(this.currentUserId);
      this.sendEmail(email, object, message);
      this.createNewUserInBDD();
    },
    sendFinalBDC() {
      this.goNext();
      console.log("sendFinalBDC");
      var email = "virginie.gospelevent@icloud.com";
      //   var email = "mouzaoui.sa@gmail.com";
      var object = `BDC Obsèques ${this.formatDate(this.formData.date)} ${this.formData.nomVille} ${
        this.formData.groupe
      }`;
      var message = this.toAdminMsg(this.currentUserId);
      this.sendEmail(email, object, message);

      email = this.formData.mail;
      object = `Réception de votre bon de commande Gospel Event`;
      message = this.finalClientMsg(this.currentUserId);
      this.sendEmail(email, object, message);
    },
    toAdminMsg(id) {
      var msg = `Pour télécharger le bon de commande: <br>
      https://gospel-bdc.web.app/obseques?id=${id}&admin=true  <br>`;
      for (var i in this.formData) {
        if (this.VarLab.map((e) => e.nomVariable).indexOf(i) !== -1 && this.formData[i] !== " ") {
          msg += `<br> ${
            this.VarLab.map((e) => e.label)[this.VarLab.map((e) => e.nomVariable).indexOf(i)]
          } <strong>${this.testIfitIsADate(this.formData[i])}</strong>`;
        }
      }
      return msg;
    },
    sendMailToAdmin() {},
    goBack() {
      var e6 = this.formData.e6;
      if (e6 == 1) {
        this.formData.e6 = "";
      } else {
        this.formData.e6--;
      }
    },
    goNext() {
      var e6 = this.formData.e6;
      if (e6 == "") {
        this.formData.e6 = 1;
      } else if (e6 > 1) {
        this.formData.e6++;
      } else {
        this.formData.e6++;
      }
      console.log(e6);
      console.log(this.formData.e6);
      this.saveCurrentData();
      window.scrollTo(0, 0);
    },
    saveCurrentData() {
      if (this.currentUserId !== "") {
        this.updateUserInBDD();
      }
    },
    createNewUserInBDD() {
      this.loading = true;
      console.log("createNewUserInBDD");
      this.tmpLastSave = new Date();
      var url = this.$store.state.url;
      var data = JSON.parse(JSON.stringify(this.formData));
      data.id = this.currentUserId;
      console.log(data);
      var action = "insert";
      var table = "bddObseques";
      var querry =
        url +
        "?action=" +
        action +
        "&table=" +
        table +
        "&data=" +
        encodeURIComponent(JSON.stringify(data));
      fetch(querry)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.loading = false;
          this.dataChange = false;
        })
        .catch((err) => console.log(err.message));
    },
    updateUserInBDD() {
      this.loading = true;
      this.tmpLastSave = new Date();
      this.formData.id = this.currentUserId;
      var url = this.$store.state.url;
      var data = JSON.parse(JSON.stringify(this.formData));
      console.log(data);
      var action = "update";
      var table = "bddObseques";
      var id = this.formData.id;
      delete data.row;
      var querry =
        url +
        "?action=" +
        action +
        "&table=" +
        table +
        "&id=" +
        id +
        "&data=" +
        encodeURIComponent(JSON.stringify(data));
      fetch(querry)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.loading = false;
          this.dataChange = false;
          this.userSaving = false;
        })
        .catch((err) => console.log(err.message));
    },
    getDataOfExistingUser(id) {
      var vm = this;
      vm.loading = true;
      var url = this.$store.state.url;
      var data = JSON.parse(JSON.stringify(this.formData));
      console.log(data);
      var action = "read";
      var table = "bddObseques";
      var q = url + "?action=" + action + "&table=" + table + "&id=" + id;
      console.log(q);
      fetch(q)
        .then((res) => res.json())
        .then((data) => {
          console.log(data.data.date);
          if (data.success) {
            data.data.documentComplLe = this.formatDate2(data.data.documentComplLe);
            data.data.date = this.formatDate2(data.data.date);
            vm.formData = data.data;
            vm.loading = false;
            this.dataChange = false;
          } else {
            console.log(data);
          }
        })
        .catch((err) => console.log(err.message));
    },
    generateNewUserId() {
      return Math.random() // Generate random number, eg: 0.123456
        .toString(36) // Convert  to base-36 : "0.4fzyo82mvyr"
        .slice(-8); // Cut off last 8 characters : "yo82mvyr"
    },
    test(e) {
      console.log(e);
    },
    firstTimeConnectionMsg(id) {
      var msg = `Bonjour ${this.formData.Prénom.trim()},<br><br>
      Voici le lien qui vous permet de finaliser votre bon de commande: <br>
      https://gospel-bdc.web.app/obseques?id=${id}<br><br>
      Si vous le souhaitez, vous pouvez joindre Virginie DORÉ sur son mobile au 07 68 88 94 36 pour toute précision.<br><br>
      Bien à vous,<br>
      L'équipe Gospel Event
      `;
      return msg;
    },
    finalClientMsg() {
      var msg = `Bonjour ${this.formData.Prénom.trim()},<br><br>
      Nous avons bien reçu votre bon de commande. <br>
      Virginie va vous revenir dans les meilleurs délais.<br><br>
      Bien à vous,<br>
      L'équipe Gospel Event
      `;
      return msg;
    },
    sendEmail(email, object, message) {
      var url = this.$store.state.urlMail;
      this.loading = true;
      // var groupe = this.state.groupe;
      console.log(url + "?message=" + message + "&object=" + object + "&email=" + email);
      fetch(
        url + "?message=" + encodeURIComponent(message) + "&object=" + object + "&email=" + email
      )
        .then((res) => res.json())
        .then((da) => {
          console.log(da);
          this.loading = false;
          this.dataChange = false;
          this.snackbar = true;
        })
        .catch((err) => console.log(err.message));
    },
    saveFilterTodb(d) {
      var url = this.$store.state.url;
      console.log(d);
      var data = JSON.parse(JSON.stringify(d));
      console.log(data);
      var action2 = "insert";
      var table2 = "bddObseques";
      var q =
        url +
        "?action=" +
        action2 +
        "&table=" +
        table2 +
        "&data=" +
        encodeURIComponent(JSON.stringify(data));
      fetch(q)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          // return(data)
          // d.id = data.data.id;
          // d.saved = true;
        })
        .catch((err) => console.log(err.message));
    },
    testIfitIsADate(date) {
      // console.log(date);
      if (isNaN(Date.parse(date)) || String(date).length < 6) {
        //not a date
        return date;
      } else {
        // is a date => format
        return this.formatDate(date);
      }
    },

    formatDate(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${day}/${month}/${year}`;
    },
    formatDate2(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${year}-${month}-${day}`;
    },
  },
  watch: {
    formData: {
      handler() {
        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
        var vm = this;
        vm.dataChange = true;
        console.log("formData hase changed");
      },
      deep: true,
    },
  },
};
</script>
<style>
.v-chip .v-chip__content {
  margin: 10px;
}
.v-chip-group .v-slide-group__content {
  justify-content: center;
}
.v-stepper__step {
  /* flex: 1 1; */
  /* flex-wrap: nowrap;
  padding: 15px !important; */
}
.v-stepper__header {
  height: none;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}

.v-text-field .v-label {
  max-width: 90%;
  overflow: visible !important;
  text-overflow: ellipsis;
  top: 6px;
  white-space: normal !important;
  pointer-events: none;
}
.v-input__control {
  flex-direction: column-reverse !important;
}
.v-input {
  /* max-width: 500px !important;
  display: flex;
  justify-content: center;
  margin: 0px; */
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  margin: 0px !important;
  overflow: hidden;
}
.v-stepper__step {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 15px !important;
  position: relative;
}
.v-sheet.v-stepper:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.v-stepper__header {
  height: 72px;
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-shadow: none !important;
}
.v-stepper__content {
  top: 0;
  padding: 0px 0px 0px 0px !important;
}
.theme--light.v-card > .v-card__text,
.theme--light.v-card > .v-card__subtitle {
  padding: 0px 0px 0px 0px !important;
}
.v-text-field.v-text-field--enclosed {
  max-width: 430px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.container {
  width: 100%;
  padding: 12px;
  padding-top: 0px;
  margin-right: auto;
  margin-left: auto;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  width: 100%;
  padding: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 0 !important;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.v-input--hide-details > .v-input__control > .v-input__slot {
  display: flex;
  justify-content: center;
}
.v-list-item__title,
.v-list-item__subtitle {
  flex: 1 1 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal !important;
}

.c6 {
  font-weight: 700;
}
</style>
